export default __webpack_public_path__ + "static/media/1b2a482711ad05f0c89b36988b1cd3a9.png";